import { number, shape } from 'prop-types';

export default shape({
  ID: number // trail_id
});
